import React, { useCallback, useContext } from 'react';

import EmailDialogForm from 'Common/Forms/EmailForm';
import { NotificationTypeEnum } from 'model/notification-type.enum';

import { PrescriptionContext } from '../../prescription.context';

export default function EmailDialog() {
  const { setEmailDialogOpened, reload, newEmailDialog, selectedPrescription } = useContext(PrescriptionContext);

  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEmailDialogOpened(false);
    },
    [reload, setEmailDialogOpened]
  );

  return (
    <EmailDialogForm
      open={newEmailDialog}
      onClose={closeDialog}
      notificationType={NotificationTypeEnum.PRESCRIPTION}
      notificationReferenceId={selectedPrescription?.id}
    />
  );
}
